import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetOversightActivityCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightActivityCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetOversightActivityCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetOversightActivityCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    assessment_activity_aggregate: {
      aggregate: toAggregate(data.oversightActivity),
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetOversightActivityCountDocument,
});
